import './vendor';
import * as angular from 'angular';
import * as _ from 'lodash';
import stringToDate from "./services/utility/stringToDate";
import { States } from "./shared/config/constant.module";
import { StateParams } from "./common";
import appTemplate from "./layout/app.tpl.html";
import initializePopups from "./popups";
import "./scss";
import './components/angular-dimple/angular-dimple';
import './appInsightsConfig';
import EnvironmentName, { Environment } from "./shared/config/environment";
import LayoutModuleName from "./layout/index";
import DirectivesModuleName from "./directives/index";
import FiltersModuleName from "./filters/index";
import LoaderName from "./components/loader/loader.directive";
import ControllersName from "./controllers/index";
import InterceptorsName from "./services/http/http.interceptors";
import NotifyServiceName, { NotifyService } from "./services/notify/notify.service";
import AuthDataServiceName, { AuthDataService } from "./services/auth/authData.service";
import StateRolesServiceName, { StateRolesService } from "./services/stateRoles/stateRoles.service";
import * as material from 'angular-material';
import './shared/polyfill';

initializePopups();

angular.module('aps', [
	/* angular */
	'ngAnimate',
	'ngSanitize',
	'ngMessages',
	/* vendor */
	'ui.router',
	'mm.foundation',
	'angularMoment',
	'react',
	'ngCsv',
	'nvd3',
	'as.sortable',
	'angular-dimple',
	/* app */
	'aps.services.appInsights',
	'textAngular',
	EnvironmentName,
	LayoutModuleName,
	DirectivesModuleName,
	LoaderName,
	ControllersName,
	InterceptorsName,
	NotifyServiceName,
	AuthDataServiceName,
	StateRolesServiceName,
	material,
	FiltersModuleName
])
	.run(function ($rootScope,
		$state: any,
		$stateParams: StateParams,
		$window: angular.IWindowService,
		$timeout: angular.ITimeoutService,
		$http: angular.IHttpService,
		$q: angular.IQService,
		$transitions: any,
		environment: Environment,
		authDataService: AuthDataService,
		notifyService: NotifyService,
		appInsightsService: any,
		stateRolesService: StateRolesService) {
		$rootScope.$state = $state;
		$rootScope.$stateParams = $stateParams;
		let checkInterval = 60 * 60 * 1000;

		let promiseProto = Object.getPrototypeOf($q.defer().promise);

		promiseProto.success = function (fn) {
			this.then(function (result) {
				fn(result.data);
			});
			return this;
		};

		promiseProto.error = function (fn) {
			this.then(null, fn);
			return this;
		};

		/**  enable $transitions.onStart for V1 redirect */
		//$transitions.onStart({}, function (trans) {
		
		/**  enable $transitions.onBefore for V2 redirect	*/
		$transitions.onBefore({}, function (trans) {
			let toState = trans.$to();						
			let toParams = trans.params('to');

			/**V1 redirect for login and reset password */
			 
			/* if (toState.name === States.SIGN_IN || toState.name === States.RESET_PASSWORD) {
				return;
			} */
			/** End of V1 redirect for login and reset password */

			/**V2 redirect for login and reset password */

			if (toState.name === States.SIGN_IN || toState.name === States.RESET_PASSWORD) {
				let uri = `v2/#/`
				setTimeout(() => {
					$window.location.href = uri;
				});
				return false;
			}
			/** End of V2 redirect for login and reset password */
			
			let userId = authDataService.getUserId();
			if (!userId && toParams.userId) {
				userId = toParams.userId;
				authDataService.setUserId(toParams.userId);
			}
			let roles = authDataService.getRoles();
			if (!userId || !roles || roles.length === 0) {
				if (!_.find([States.SIGN_IN, States.RESET_PASSWORD], toState.name)) {
					return $state.target(States.SIGN_IN);
				}
				return;
			}

			/**V2 redirect for select role*/
			if (toState.name === States.SELECT_ROLE) {
				let uri = `v2/#/auth/select-role?userId=${userId}`;
				setTimeout(() => {
					$window.location.href = uri;
				});
				return false;
			}

			if (toState.data && toState.data.v2Uri) {
				let uri = `v2/#/${toState.data.v2Uri}?plantId=${toParams.plantId}&shopId=${toParams.shopId}&userId=${toParams.userId}`
				// Forward the state params a v2 page needs beyond the plant/shop/user
				// context - e.g. the check list report's startDate/endDate window from
				// the line sheet - for states that declare them in data.v2Params.
				_.forEach(toState.data.v2Params || [], (name: string) => {
					let value = toParams[name];
					if (value !== undefined && value !== null && value !== '') {
						uri += `&${name}=${encodeURIComponent(value)}`;
					}
				});
				setTimeout(() => {
					$window.location.href = uri;
				});
				return;
			}
			/** End of V2 redirect for select role*/

			let selectedRoleLocation = authDataService.getSelectedRoleLocation();
			if (!stateRolesService.stateRoleRequirementsSatisfied(toState.data)) {
				notifyService.error('Current role not permitted to access requested functionality');
				return false;
			}

			if (!selectedRoleLocation) {
				if (toState.name !== States.SELECT_ROLE) {
					return $state.target(States.SELECT_ROLE, { userId: userId });
				}
			}
		});

		function checkForNewVersion() {
            $http.get('/environment.js?v=' + Date.now(), { cache: "reload" })
                .then(function (data: any) {
                    var newVersion = extractVersion(data.data);
					var currentVersion = localStorage.getItem('appVersion');

                    if (newVersion && currentVersion && currentVersion !== newVersion) {
						if (confirm('A new version is available. Reload to update?')) {
							localStorage.setItem('appVersion', newVersion);
							$window.location.reload();
						}
					} else {
						localStorage.setItem('appVersion', newVersion);
					}
                })
                .catch(function (error) { 
					console.error('Error checking version:', error);
                });
        }
		function extractVersion(data) {
			const versionMatch = /"VERSION"\s*:\s*["']([\d.]+)["']/.exec(data);
			return versionMatch ? versionMatch[1] : null;
		}
		checkForNewVersion();

		$timeout(checkForNewVersion, checkInterval);
		appInsightsService.initialize($transitions);
	})

	.config(function (environment: Environment,
		$stateProvider: angular.ui.IStateProvider,
		$urlRouterProvider: angular.ui.IUrlRouterProvider,
		$locationProvider: any,
		$compileProvider: angular.ICompileProvider,
		$httpProvider: angular.IHttpProvider) {
		if (environment.ENV_TYPE === 'working') {
			$compileProvider.debugInfoEnabled(false);
		}

		$stateProvider
			.state({
				name: States.ABSTRACT,
				url: '/aps?plantId&shopId&userId',
				abstract: true,
				params: {
					plantId: null,
					shopId: null,
					userId: null
				},
				template: appTemplate
			});
			/* $stateProvider.state({
				name: States.SCORECARDV2,
				url: '/scorecard',
				data: {
					v2Uri: 'aps/reports/lpa-score-card'
				}
			});
			$stateProvider.state({
				name: States.DEFECTS_REPORT_V2,
				url: '/defects-report',
				data: {
					v2Uri: 'aps/reports/defects-report'
				}
			});
			$stateProvider.state({
				name: States.BATCH_SUMMARY_V2,
				url: '/admin/batchSummary',
				data: {
					v2Uri: 'aps/settings/batch-summary'
				}
			});*/
			$stateProvider.state({
				name: States.DOWNTIME_REPORT_V2,
				url: '/downtime-report',
				data: {
					v2Uri: 'aps/reports/downtime-report'
				}
			});

			$stateProvider.state({
				name: States.TOOLCHANGE_HISTORY_REPORT,
				url: '/toolchange-report',
				data: {
					v2Uri: 'aps/reports/toolchange-report'
				}
			});

			$stateProvider.state({
				name: States.HOTENDBONUS_REPORT_V2,
				url: '/hotendbonus-report',
				data: {
					v2Uri: 'aps/reports/hotendbonus-report'
				}
			});
			$stateProvider.state({
			name: States.SHOP_COUNT_SUMMARY_V2,
			url: '/shop-count-summary',
			data: {
				v2Uri: 'aps/reports/shop-count-summary'
			}
		});

			/* $stateProvider.state({
				name: States.GLOBAL_NOTIFICATIONS_V2,
				url: '/sendNotification',
				data: {
					v2Uri: 'aps/settings/globalNotifications'
				}
			}); */

		let transformResponse = $httpProvider.defaults.transformResponse as angular.IHttpResponseTransformer[];
		transformResponse.push(stringToDate);

		/**
		 * apply auth header to every request
		 * automatically go to login view when not authenticated
		 */
		$httpProvider.interceptors.push('httpInterceptors');

		$locationProvider.hashPrefix('');

		/**
		 * redirect to login page
		 */
		$urlRouterProvider.otherwise('/signIn');
	});



// WEBPACK FOOTER //
// ./src/app/app.ts